import { fetchAuthSession, getCurrentUser, signOut } from 'aws-amplify/auth';
import { config } from '../config';

let authType: 'aws' | 'okta' | null = null;
let oktaToken: string | null = null;
let oktaRefreshToken: string | null = null;

type AuthType = 'aws' | 'okta' | null;

export const tokenManager = {
  async getCognitoToken(): Promise<string | null> {
    try {
      const session = await fetchAuthSession();
      return session.tokens?.idToken?.toString() || null;
    } catch (error) {
      console.error('Error getting Cognito token:', error);
      return null;
    }
  },

  setOktaToken(token: string): void {
    //console.log(`Setting Okta token: ${token}`);
    sessionStorage.setItem('okta_token', token);
    this.setAuthType('okta');
  },

  getOktaToken(): string | null {
    const token = sessionStorage.getItem('okta_token');
    //console.log(`Current Okta token: ${token}`);
    return token;
  },

  setOktaRefreshToken(refreshToken: string): void {
    //console.log(`Setting Okta refresh token: ${refreshToken}`);
    sessionStorage.setItem('okta_refresh_token', refreshToken);
  },

  getOktaRefreshToken(): string | null {
    //console.log(`Current Okta refresh token: ${oktaRefreshToken}`);
    return sessionStorage.getItem('okta_refresh_token');
  },

  setAuthType(type: 'aws' | 'okta' | null): void {
    //console.log(`Setting auth type: ${type}`);
    sessionStorage.setItem('auth_type', type || '');
  },

  getAuthType(): 'aws' | 'okta' | null {
    const type = sessionStorage.getItem('auth_type') as 'aws' | 'okta' | null;
    //console.log(`Current auth type: ${type}`);
    return type;
  },

  async getToken(): Promise<string | null> {
    const authType = this.getAuthType();
    if (authType === 'aws') {
      return this.getCognitoToken();
    } else if (authType === 'okta') {
      return sessionStorage.getItem('token');
    }
    return null;
  },

  setToken(token: string, authType: 'aws' | 'okta'): void {
    sessionStorage.setItem('token', token);
    sessionStorage.setItem('authType', authType);
    //console.log(`Setting ${authType} token:`, token);
  },

  getTokenMethod: async (): Promise<string | null> => { // Renamed property
    return localStorage.getItem('authToken');
  },

  clearTokens(): void {
    //console.log('Clearing all tokens');
    sessionStorage.removeItem('token');
    sessionStorage.removeItem('authType');
  },
};
